import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { LabOrder } from '../../shared/data/lab-order';
import { LabOrderBusinessService } from '../../shared/lab-order-business.service';
import { REF_LIST } from '../../shared/lab-order-reference-api.service';
import { ReferenceListItem } from '../../shared/data/reference-list-item';
import { LensCatalogBusinessService } from '../../shared/lens-catalog-business.service';

import { LensFeature } from '../../shared/data/lens-feature';
import {SubscriptionsContainer} from '../../shared/subscriptions-container';

import { LensService } from '../lens/lens.service';

@Component({
  selector: 'app-tint',
  templateUrl: './tint.component.html',
  styleUrls: ['./tint.component.css']
})
export class TintComponent implements OnInit, OnDestroy {
  @Input() labOrder: LabOrder;

  // Arrays of Lens Feature objects to populate the drop down lists' options
  tintColors: LensFeature[];
  tintTypes: LensFeature[];
  tintSampleCodes: ReferenceListItem[];
  subs = new SubscriptionsContainer();

  disabledDropdown: boolean;
  constructor(
    private labOrderBusinessService: LabOrderBusinessService,
    private lensCatalogBusinessService: LensCatalogBusinessService,
    private lensService: LensService
  ) { }

  ngOnInit() {
    this.subs.add = this.labOrderBusinessService.getReferenceListsByNames([REF_LIST.TINT_SAMPLE_CODES])
      .subscribe(
        (data) => {
          this.tintSampleCodes = data[0];
        },
        (error) => {
          this.tintSampleCodes = null;
          console.log('Unable to retrieve tint section referencelists', error);
        }
      );

    this.subs.add = this.lensService.getMaterialCode().subscribe(
        (data) => {
          console.log('Retrieved materialCode', data);
          this.updateTintFields(data);
        },
        (error) => {
          console.log('Not connected to Lens Service');
        }
    );

    // initialize tintFields with initial material code
    this.updateTintFields(this.labOrder.lens.materialCode);

    this.tintColors = this.lensCatalogBusinessService.tintColors;
    this.tintTypes = this.lensCatalogBusinessService.tintTypes;
  }

  ngOnDestroy(): void {
    console.log(' Tint Component - ngOnDestroy ' );
    this.subs.dispose();
  }

  // enable/disable tint-related fields based on materialCode
  updateTintFields(materialCode: string) {
    let disabled: boolean = false;

    if (materialCode && (materialCode === 'GLASS' || materialCode === 'GLASS_HIGH_INDEX')) {
      disabled = true;
      this.clearTintFields();
    }

    // this will trigger the fields to enable/disable.
    this.disabledDropdown = disabled;
  }

  // going to clear tint fields when materialCode is glass.
  clearTintFields() {
    this.labOrder.lens.tintColorCode = null;
    this.labOrder.lens.tintColorDescription = null;
    this.labOrder.lens.tintTypeCode = null;
    this.labOrder.lens.tintSampleCode = null;
    this.labOrder.lens.tintSamplePercentage = null;
  }

  // if the tint color code drop-down is not 'OTHER' then
  // clear the bevel description.
  clearTintColorDescription(tintColorValue) {

    if (tintColorValue !== 'OTHER') {
      this.labOrder.lens.tintColorDescription = '';
    }
  }

  // determine if tint color description should be disabled.
  otherTintColorDisable(): boolean {
    return this.labOrder.lens.tintColorCode !== 'OTHER';
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/modify-order/tint/tint.component.ts